import baseURL from '../common/axios';
class Commonservices {

    //To Insert Rack-->Inventory API
    insertRack(dataModel) {
        return baseURL.httpMSInventoryUrl.post("RackMAS/Create", dataModel)
    }
    //To Update Rack-->Inventory API
    updateRack(dataModel) {
        return baseURL.httpMSInventoryUrl.post("RackMAS/Update", dataModel)
    }
    //To Delete Rack-->Inventory API
    deleteRack(Id) {
        return baseURL.httpMSInventoryUrl.delete("RackMAS/Delete?id=" + Id)
    }
    //Active
    active(Id, Status) {
        return baseURL.httpMSInventoryUrl.put("RackMAS/Active?id=" + Id + "&Status=" + Status + "")
    }
    //To Get Rack List-->Inventory API
    getRackList() {
        return baseURL.httpMSInventoryUrl.get("RackMAS/List")
    }
    //To Get Rack List-->Inventory API
    getRackById(Id) {
        return baseURL.httpMSInventoryUrl.get("RackMAS/Get?id=" + Id + "")
    }
    //To Get Rack List Based on StoreId-->Inventory API
    getRackByStoreId(Id) {
        return baseURL.httpMSInventoryUrl.get("Custom/GetRackByStoreId?id=" + Id + "")
    }
    //To Get Rack List Based on RoomId-->Inventory API
    getRackByRoomId(Id) {
        debugger;
        return baseURL.httpMSInventoryUrl.get("Custom/GetRackByRoomId?id=" + Id + "")
    }

}
export default new Commonservices()